// extracted by mini-css-extract-plugin
module.exports = {"container":"QuestionTooltip_container__JpKAW","text":"QuestionTooltip_text__Gz69S","icon":"QuestionTooltip_icon__p0vsB","title":"QuestionTooltip_title__bfmJc"};